export async function runSingleFlight(lockRef, onStart, action, onFinish) {
  if (lockRef.current) return false;
  lockRef.current = true;
  try {
    onStart();
    await action();
    return true;
  } finally {
    lockRef.current = false;
    onFinish();
  }
}